/* tbd product card: quick add to cart + stepper.
   Loaded once per page. A second copy is ignored (window.__tbdQuickAdd). */
(function () {
  /* One copy of this script runs per page, however many cards there are. */
  if (window.__tbdQuickAdd) return;
  window.__tbdQuickAdd = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var qty = {};   /* variant id -> quantity currently in the cart */

  function total() { var n = 0; for (var k in qty) n += qty[k]; return n; }

  function paint() {
    var cards = document.querySelectorAll('[data-tbd-quick]');
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i];
      var q = qty[el.getAttribute('data-variant-id')] || 0;
      el.querySelector('[data-tbd-add]').hidden = q > 0;
      el.querySelector('[data-tbd-stepper]').hidden = q <= 0;
      el.querySelector('[data-tbd-qty]').textContent = q;
    }
  }

  function sync(cart) {
    qty = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      qty[items[i].variant_id] = (qty[items[i].variant_id] || 0) + items[i].quantity;
    }
    paint();
  }

  function load() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function () {});
  }

  /* Keep the header cart bubble (and cart drawer, if the theme has one) in step with the cart. */
  function sectionsToRender() {
    var list = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) list.push('cart-drawer');
    return list.join(',');
  }
  function refreshSections(sections) {
    if (!sections) return;
    try {
      if (sections['cart-icon-bubble']) {
        var d1 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var s1 = d1.querySelector('.shopify-section');
        var t1 = document.getElementById('cart-icon-bubble');
        if (s1 && t1) t1.innerHTML = s1.innerHTML;
      }
      if (sections['cart-drawer']) {
        var d2 = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var s2 = d2.querySelector('#CartDrawer');
        var t2 = document.getElementById('CartDrawer');
        if (s2 && t2) t2.innerHTML = s2.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', total() === 0);
      }
    } catch (e) {}
  }

  function post(path, body) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function message(el, text) {
    var m = el.querySelector('[data-tbd-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }

  function run(el, fn) {
    if (el.getAttribute('aria-busy') === 'true') return;
    el.setAttribute('aria-busy', 'true');
    message(el, '');
    fn().catch(function () { message(el, 'something went wrong. try again?'); })
      .then(function () { el.removeAttribute('aria-busy'); });
  }

  function add(el) {
    var id = el.getAttribute('data-variant-id');
    return post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }).then(function (res) {
      if (res.status) { message(el, res.description || res.message || 'could not add this.'); return; }
      qty[id] = (qty[id] || 0) + 1;
      paint();
      refreshSections(res.sections);
    });
  }

  function setQty(el, next) {
    var id = el.getAttribute('data-variant-id');
    return post('cart/change.js', { id: String(id), quantity: next }).then(function (cart) {
      if (cart.status) { message(el, cart.description || cart.message || 'could not update.'); return; }
      sync(cart);
      refreshSections(cart.sections);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-tbd-add], [data-tbd-plus], [data-tbd-minus]');
    if (!btn) return;
    var el = btn.closest('[data-tbd-quick]');
    if (!el) return;
    var id = el.getAttribute('data-variant-id');
    var current = qty[id] || 0;
    if (btn.hasAttribute('data-tbd-add') || btn.hasAttribute('data-tbd-plus')) {
      run(el, function () { return add(el); });
    } else {
      run(el, function () { return setQty(el, Math.max(0, current - 1)); });
    }
  });

  window.tbdQuickAdd = { refresh: paint };

  window.addEventListener('pageshow', load);
  document.addEventListener('shopify:section:load', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
